import React, { useState } from 'react'
import Button from '../../Components/SelectValue/Button'
import putServices from '../../Services/put-service' 
import Backdrop from '@mui/material/Backdrop'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import Fade from '@mui/material/Fade'
import CancelRoundedIcon from '@mui/icons-material/CancelRounded'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../Components/SelectValue/FormikControl'
import swal from 'sweetalert'
import Loading from '../../Components/SelectValue/Loading'

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'white',
    boxShadow: 24,
}

function Profile() {
    const user = localStorage.getItem('userdetails')
    const userValue = JSON.parse(user)
    
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [loading, setLoading] = useState(false)

    const initialValues = {
        firstName: userValue.firstName,
        lastName: userValue.lastName,
        phoneNumber: userValue.phoneNumber
    }

    const validationSchema = Yup.object().shape({
        firstName: Yup.string().required('First name is required'),
        lastName: Yup.string().required('Last name is required'),
        phoneNumber: Yup.string().required('Phone number is required')
    })

    const onSubmit = async (values) => {
        setLoading(true)
        console.log('Form data', values)
        
        try {
            const response = await putServices.editProfile(values)
            console.log(response.data)
            setLoading(false)
            
            if (response.data.status === '2000') {
                // Update localStorage with new values
                const updatedUser = {
                    ...userValue,
                    firstName: values.firstName,
                    lastName: values.lastName,
                    phoneNumber: values.phoneNumber
                }
                localStorage.setItem('userdetails', JSON.stringify(updatedUser))
                
                swal("Profile updated successfully!").then((result) => {
                    setIsModalOpen(false)
                    window.location.reload()
                })
            } else {
                swal(response.data.description)
            }
        } catch (error) {
            setLoading(false)
            console.error('Error updating profile:', error)
            swal('Error updating profile. Please try again.')
        }
    }

    const handleClose = () => {
        setIsModalOpen(false)
    }

    return (
        <div>
            <div className='grid grid-cols-2 md:grid-cols-2 gap-4 my-3'>
                <div>
                    <p className='mb-2 font-[400] text-[14px] text-[#44474E]'>Full name</p>
                    <p className='mb-2 font-[500] text-[16px] text-[#1E222B]'>
                        {userValue.firstName} {userValue.lastName}
                    </p>
                </div>
            </div>
            
            <div className='grid grid-cols-2 md:grid-cols-2 gap-4 my-3'>
                <div>
                    <p className='mb-2 font-[400] text-[14px] text-[#44474E]'>Email address</p>
                    <p className='mb-2 font-[500] text-[16px] text-[#1E222B]'>{userValue.emailAddress}</p>
                </div>
            </div>
           
            <div className='grid grid-cols-2 md:grid-cols-2 gap-4 my-3'>
                <div>
                    <p className='mb-2 font-[400] text-[14px] text-[#44474E]'>Role</p>
                    <p className='mb-2 font-[500] text-[16px] text-[#1E222B]'>{userValue.userRole}</p>
                </div>
            </div>
            
            <div className='grid grid-cols-2 md:grid-cols-2 gap-4 my-3'>
                <div>
                    <p className='mb-2 font-[400] text-[14px] text-[#44474E]'>Phone number</p>
                    <p className='mb-2 font-[500] text-[16px] text-[#1E222B]'>{userValue.phoneNumber}</p>
                </div>
            </div>
            
            <div className='mt-5'>
                <Button
                    name='Edit Profile'
                    onClick={() => setIsModalOpen(true)}
                />
            </div>

            {/* Modal */}
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={isModalOpen}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={isModalOpen}>
                    <Box sx={style} className='rounded-lg p-6 pt-10'>
                        <Loading open={loading} />
                        
                        <div className='md:mt-8'>
                            <div className='flex justify-end my-5'>
                                <CancelRoundedIcon 
                                    className='cursor-pointer' 
                                    onClick={handleClose} 
                                    fontSize='large' 
                                />
                            </div>
                            
                            <div>
                                <p className='my-5 text-center text-back-color2 font-[500] text-[24px]'>
                                    Edit Profile
                                </p>
                            </div>
                            
                            <div>
                                <Formik
                                    initialValues={initialValues}
                                    validationSchema={validationSchema}
                                    onSubmit={onSubmit}
                                >
                                    {formik => (
                                        <Form>
                                            <div className='grid mb-3 md:grid-cols-2 gap-3 lg:grid-cols-1'>
                                                <FormikControl
                                                    control='input'
                                                    type='text'
                                                    label='First name'
                                                    name='firstName'
                                                />
                                            </div>
                                            
                                            <div className='grid mb-3 md:grid-cols-2 lg:grid-cols-1 gap-3'>
                                                <FormikControl
                                                    control='input'
                                                    type='text'
                                                    label='Last name'
                                                    name='lastName'
                                                />
                                            </div>
                                            
                                            <div className='grid mb-3 md:grid-cols-2 lg:grid-cols-1 gap-3'>
                                                <FormikControl
                                                    control='input'
                                                    type='tel'
                                                    label='Phone number'
                                                    name='phoneNumber'
                                                />
                                            </div>
                                            
                                            <div className='grid mb-3 md:grid-cols-2 lg:grid-cols-1 gap-3'>
                                                <div>
                                                    <label className='block mb-2 font-[400] text-[14px] text-[#44474E]'>
                                                        Email address
                                                    </label>
                                                    <input
                                                        type='email'
                                                        value={userValue.emailAddress}
                                                        disabled
                                                        className='w-full p-3 outline-0 rounded-lg border bg-gray-100 cursor-not-allowed'
                                                    />
                                                </div>
                                            </div>
                                            
                                            <div className='grid grid-cols-1 mb-5 mt-10'>
                                                <Button name='Save Changes' />
                                            </div>
                                        </Form>
                                    )}
                                </Formik>
                            </div>
                        </div>
                    </Box>
                </Fade>
            </Modal>
        </div>
    )
}

export default Profile